/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Infinitesimal small number
 * This "stupidity" is here because javascript is sometimes not precise in the last decimal digit
 * See tests of stripInfatesimals
 * TODO: Move to indipendent library
 */
var ε = 0.0000000000000002;
/**
 * Threshold bellow which are decimal numbers so negligible that can be stripped from its main part
 * See tests of stripInfatesimals
 */
var NEGLIGIBLE_THRESHOLD = 0.000000001;

var AXES = ['x', 'y', 'z'];
/**
 * TODO: Use one of IVector vs. IVectorData and deprecte other one
 */

function fullAngle(unit) {
    switch (unit) {
        case '(rad)':
        case 'rad':
            return Math.PI * 2;
        case '(deg)':
        case 'deg':
            return 360;
        case 'grad':
            return 400;
        case 'turn':
            return 1;
        default:
            throw new Error("Unknown angle unit \"" + unit + "\".");
    }
}

function modulo(dividend, divisor) {
    // Note: The strange way how I use % is due to stupid JavaScript modulo bug.
    return ((dividend % divisor) + divisor) % divisor;
}

function convertAngle(from, to, value) {
    /*
    TODO: optimalizations with "(rad)" vs "rad"

    if (from === to) {
        return modulo(value, fullAngle(from));
    }
    */
    var fullFrom = fullAngle(from);
    var fullTo = fullAngle(to);
    return modulo((value / fullFrom) * fullTo, fullTo);
}

//  TODO: Move to indipendent library
function stripInfatesimal(value) {
    if (value === NaN) {
        return NaN;
    }
    return stripInfatesimalOneSide(value, true);
}
function stripInfatesimalOneSide(value, cropSecondSide) {
    if (value <= ε && value >= -ε) {
        return 0;
    }
    if (value < 0) {
        return -stripInfatesimalOneSide(-value, cropSecondSide);
    }
    if (value === Infinity) {
        return Infinity;
    }
    if (value < 1) {
        return stripInfatesimalOneSide(value * 10, cropSecondSide) / 10;
    }
    var decimal = value - Math.floor(value);
    if (decimal === 0) {
        return value;
    }
    var whole = value - decimal;
    if (decimal <= NEGLIGIBLE_THRESHOLD) {
        return whole;
    }
    if (cropSecondSide) {
        return whole + (1 - stripInfatesimalOneSide(1 - decimal, false));
    }
    return whole + decimal;
}

// TODO: toCss toTopLeft as helpers
// TODO: ? Vector is kind of Transform with only a translation
// TODO: ? add, subtract, etc should take also a Transform
var Vector = /** @class */ (function () {
    function Vector(x, y, z) {
        if (typeof x === 'number' || x === undefined || x === null) {
            this.x = x || 0;
            this.y = y || 0;
            this.z = z || 0;
        }
        else {
            var vector = x;
            this.x = vector.x || 0;
            this.y = vector.y || 0;
            this.z = vector.z || 0;
        }
    }
    Vector.zero = function () {
        return new Vector();
    };
    Vector.cube = function (scale) {
        if (scale === void 0) { scale = 1; }
        return new Vector(1, 1, 1).scale(scale);
    };
    Vector.square = function (scale) {
        if (scale === void 0) { scale = 1; }
        return new Vector(1, 1).scale(scale);
    };
    Vector.fromObject = function (vector, axisMapping) {
        if (vector instanceof Vector) {
            return vector;
        }
        if (typeof vector === 'object') {
            var _a = __read(axisMapping || AXES, 3), x = _a[0], y = _a[1], z = _a[2];
            // @ts-expect-error
            return new Vector(vector[x], vector[y], vector[z]);
        }
        return new Vector();
    };
    Vector.fromArray = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        if (Array.isArray(values[0])) {
            return Vector.fromArray.apply(Vector, __spreadArray([], __read(values[0]), false));
        }
        return new (Vector.bind.apply(Vector, __spreadArray([void 0], __read(values), false)))();
    };
    Vector.fromPolar = function (rotation, distance) {
        if (distance === void 0) { distance = 1; }
        // TODO: also interface with object options
        return new Vector(Math.cos(rotation) * distance, Math.sin(rotation) * distance);
    };
    /*
    public static fromTopLeft(boundingBox: {
        top: number;
        left: number;
    }): Vector {
        // TODO: !!! To utils
        return new Vector(boundingBox.left, boundingBox.top, 0);
    }
    */
    // Note: Static methods bellow have instance equivalents
    Vector.clone = function (vector) {
        return new Vector(vector.x, vector.y, vector.z);
    };
    Vector.add = function () {
        var vectors = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            vectors[_i] = arguments[_i];
        }
        return new Vector(vectors.reduce(function (x, vector) { return x + (vector.x || 0); }, 0), vectors.reduce(function (y, vector) { return y + (vector.y || 0); }, 0), vectors.reduce(function (z, vector) { return z + (vector.z || 0); }, 0));
    };
    Vector.subtract = function (vectorA, vectorB) {
        return Vector.add(vectorA, Vector.fromObject(vectorB).negate());
    };
    Vector.multiply = function () {
        var vectors = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            vectors[_i] = arguments[_i];
        }
        return new Vector(vectors.reduce(function (x, vector) { return x * (vector.x || 0); }, 1), vectors.reduce(function (y, vector) { return y * (vector.y || 0); }, 1), vectors.reduce(function (z, vector) { return z * (vector.z || 0); }, 1));
    };
    Vector.divide = function (vectorA, vectorB) {
        return Vector.multiply(vectorA, Vector.fromObject(vectorB).inverse());
    };
    Vector.scale = function (vector, scale) {
        return new Vector((vector.x || 0) * scale, (vector.y || 0) * scale, (vector.z || 0) * scale);
    };
    Vector.rotate = function (vector, rotate) {
        return Vector.mapEachPlane(vector, function (ortogonalAxis, vectorBD) {
            var rotateAxis = rotate[ortogonalAxis] || 0;
            var rotation = vectorBD.rotation();
            var distance = vectorBD.distance();
            return Vector.fromPolar(rotation + rotateAxis, distance);
        });
    };
    Vector.mapEachPlane = function (vector, callback) {
        var e_1, _a;
        var vectorObject = Vector.fromObject(vector);
        var _loop_1 = function (axis) {
            vectorObject = Vector.mapPlane(vectorObject, axis, function (vectorBD) {
                return callback(axis, vectorBD);
            });
        };
        try {
            for (var AXES_1 = __values(AXES), AXES_1_1 = AXES_1.next(); !AXES_1_1.done; AXES_1_1 = AXES_1.next()) {
                var axis = AXES_1_1.value;
                _loop_1(axis);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (AXES_1_1 && !AXES_1_1.done && (_a = AXES_1.return)) _a.call(AXES_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return vectorObject;
    };
    Vector.mapPlane = function (vector, ortogonalAxis, callback) {
        var _a, _b, _c;
        var _d = Vector.fromObject(vector), x = _d.x, y = _d.y, z = _d.z;
        switch (ortogonalAxis) {
            case 'x':
                _a = __read(Vector.fromObject(callback(new Vector(y, z))).toArray2D(), 2), y = _a[0], z = _a[1];
                break;
            case 'y':
                _b = __read(Vector.fromObject(callback(new Vector(x, z))).toArray2D(), 2), x = _b[0], z = _b[1];
                break;
            case 'z':
                _c = __read(Vector.fromObject(callback(new Vector(x, y))).toArray2D(), 2), x = _c[0], y = _c[1];
                break;
        }
        return new Vector(x, y, z);
    };
    Vector.dotProduct = function (vectorA, vectorB) {
        var a = Vector.fromObject(vectorA);
        var b = Vector.fromObject(vectorB);
        return a.x * b.x + a.y * b.y + a.z * b.z;
    };
    Vector.crossProduct = function (vectorA, vectorB) {
        var a = Vector.fromObject(vectorA);
        var b = Vector.fromObject(vectorB);
        return new Vector(a.y * b.z - a.z * b.y, a.z * b.x - a.x * b.z, a.x * b.y - a.y * b.x);
    };
    Vector.average = function () {
        var vectors = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            vectors[_i] = arguments[_i];
        }
        return Vector.add.apply(Vector, __spreadArray([], __read(vectors), false)).scale(1 / vectors.length);
    };
    Vector.isEqual = function (vectorA, vectorB) {
        var e_2, _a;
        try {
            // TODO: Maybe spread arguments as in add
            for (var AXES_2 = __values(AXES), AXES_2_1 = AXES_2.next(); !AXES_2_1.done; AXES_2_1 = AXES_2.next()) {
                var axis = AXES_2_1.value;
                if (Math.abs((vectorA[axis] || 0) - (vectorB[axis] || 0)) > ε) {
                    return false;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (AXES_2_1 && !AXES_2_1.done && (_a = AXES_2.return)) _a.call(AXES_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return true;
    };
    Vector.stripInfatesimals = function (vector) {
        var e_3, _a;
        // TODO: Use in methods with problematic infatesimals to stop using toBeDeepCloseTo and toMatchCloseTo in tests
        // TODO: Use here Vector.map
        var vectorObject = Vector.clone(vector);
        try {
            for (var _b = __values(['x', 'y', 'z' /* TODO: Some central place or getter for all axis */]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var axis = _c.value;
                vectorObject[axis] = stripInfatesimal(vectorObject[axis]);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return vectorObject;
    };
    Vector.isZero = function (vector) {
        return Vector.isEqual({}, vector);
    };
    Vector.distance = function (vectorA, vectorB) {
        if (vectorB === void 0) { vectorB = Vector.zero(); }
        return Math.sqrt(Vector.distanceSquared(vectorA, vectorB));
    };
    Vector.distanceSquared = function (vectorA, vectorB) {
        if (vectorB === void 0) { vectorB = Vector.zero(); }
        return (Math.pow(((vectorA.x || 0) - (vectorB.x || 0)), 2) +
            Math.pow(((vectorA.y || 0) - (vectorB.y || 0)), 2) +
            Math.pow(((vectorA.z || 0) - (vectorB.z || 0)), 2));
    };
    Vector.rotation = function (vectorA, vectorB) {
        if (vectorB === void 0) { vectorB = Vector.zero(); }
        // TODO: Just for compatibility, because it does not make sence in Vector
        // TODO: Work with 3D rotation
        return Math.atan2((vectorA.y || 0) - (vectorB.y || 0), (vectorA.x || 0) - (vectorB.x || 0));
    };
    Vector.cubeMax = function (vector) {
        // TODO: Maybe create boxMin and boxVolume and boxRound
        var value = Math.max.apply(Math, __spreadArray([], __read(Vector.fromObject(vector).toArray()), false));
        return Vector.cube(value);
    };
    Vector.map = function (vector, modifier) {
        var e_4, _a;
        var mappedVector = Vector.clone(vector);
        try {
            // TODO: USE apply in all other methods to avoid making same thing 3x
            for (var _b = __values(['x', 'y', 'z' /* TODO: Some central place or getter for all axis */]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var axis = _c.value;
                mappedVector[axis] = modifier(vector[axis] || 0, axis);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return mappedVector;
    };
    Vector.rearrangeAxes = function (vector, modifier) {
        var _a;
        var x = vector.x, y = vector.y, z = vector.z;
        _a = __read(modifier([x || 0, y || 0, z || 0]), 3), x = _a[0], y = _a[1], z = _a[2];
        return new Vector(x, y, z);
    };
    Vector.apply = function (vector, modifier) {
        if (typeof modifier === 'function') {
            return Vector.fromObject(modifier(Vector.fromObject(vector)));
        }
        else {
            return Vector.fromObject(modifier.applyOnVector(Vector.fromObject(vector)));
        }
    };
    Vector.applyWithin = function (vector, context, modifier) {
        var vectorInContext = Vector.apply(vector, context);
        var modifiedVectorInContext = modifier(vectorInContext);
        var modifiedVector = Vector.apply(modifiedVectorInContext, context.inverse());
        console.log({ context: context, vector: vector, vectorInContext: vectorInContext, modifiedVectorInContext: modifiedVectorInContext, modifiedVector: modifiedVector });
        return modifiedVector;
    };
    Vector.to2D = function (vector) {
        return new Vector(vector.x, vector.y);
    };
    Vector.toJSON = function (vector) {
        return Vector.toObject(vector);
    };
    Vector.toObject = function (vector, axisMapping) {
        var e_5, _a;
        var object = {};
        var array = Vector.toArray(vector);
        try {
            for (var _b = __values((axisMapping || AXES)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var axis = _c.value;
                object[axis] = (array.shift() || 0);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return object;
    };
    Vector.toObject2D = function (vector) {
        return { x: vector.x || 0, y: vector.y || 0 };
    };
    Vector.toObject3D = function (vector) {
        return { x: vector.x || 0, y: vector.y || 0, z: vector.z || 0 };
    };
    Vector.toArray = function (vector) {
        return [vector.x || 0, vector.y || 0, vector.z || 0];
    };
    Vector.toArray2D = function (vector) {
        return [vector.x || 0, vector.y || 0];
    };
    Vector.toArray3D = function (vector) {
        return [vector.x || 0, vector.y || 0, vector.z || 0];
    };
    Vector.toString = function (vector) {
        return "[" + (vector.x || 0) + "," + (vector.y || 0) + "," + (vector.z || 0) + "]";
    };
    Vector.toString2D = function (vector) {
        return "[" + (vector.x || 0) + "," + (vector.y || 0) + "]";
    };
    Vector.toString3D = function (vector) {
        return "[" + (vector.x || 0) + "," + (vector.y || 0) + "," + (vector.z || 0) + "]";
    };
    Vector.prototype.inverse = function () {
        return this.map(function (v) { return 1 / v; }).stripInfatesimals();
    };
    Vector.prototype.negate = function () {
        return this.scale(-1);
    };
    Vector.prototype.half = function () {
        return this.scale(1 / 2);
    };
    Vector.prototype.third = function () {
        return this.scale(1 / 3);
    };
    Vector.prototype.quarter = function () {
        return this.scale(1 / 4);
    };
    Vector.prototype.double = function () {
        return this.scale(2);
    };
    Vector.prototype.triple = function () {
        return this.scale(3);
    };
    // Note: Bellow are instance equivalents of static methods
    // TODO: !!! Auto-generate them
    // TODO: !!! Generate inPlace methods automatically
    Vector.prototype.clone = function () {
        return Vector.clone(this);
    };
    // TODO: updateWithMutation
    Vector.prototype.add = function () {
        var vectors = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            vectors[_i] = arguments[_i];
        }
        return Vector.add.apply(Vector, __spreadArray([this], __read(vectors), false));
    };
    Vector.prototype.subtract = function (vectorB) {
        return Vector.subtract(this, vectorB);
    };
    Vector.prototype.multiply = function () {
        var vectors = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            vectors[_i] = arguments[_i];
        }
        return Vector.multiply.apply(Vector, __spreadArray([this], __read(vectors), false));
    };
    Vector.prototype.divide = function (vectorB) {
        return Vector.divide(this, vectorB);
    };
    Vector.prototype.scale = function (scale) {
        return Vector.scale(this, scale);
    };
    Vector.prototype.rotate = function (rotate) {
        return Vector.rotate(this, rotate);
    };
    Vector.prototype.mapEachPlane = function (callback) {
        return Vector.mapEachPlane(this, callback);
    };
    Vector.prototype.mapPlane = function (ortogonalAxis, callback) {
        return Vector.mapPlane(this, ortogonalAxis, callback);
    };
    Vector.prototype.dotProduct = function (vectorB) {
        return Vector.dotProduct(this, vectorB);
    };
    Vector.prototype.crossProduct = function (vectorB) {
        return Vector.crossProduct(this, vectorB);
    };
    Vector.prototype.isEqual = function (vectorB) {
        return Vector.isEqual(this, vectorB);
    };
    Vector.prototype.isZero = function () {
        return Vector.isZero(this);
    };
    Vector.prototype.stripInfatesimals = function () {
        return Vector.stripInfatesimals(this);
    };
    Vector.prototype.distance = function (vectorB) {
        return Vector.distance(this, vectorB);
    };
    Vector.prototype.distanceSquared = function (vectorB) {
        return Vector.distanceSquared(this, vectorB);
    };
    Vector.prototype.rotation = function (vectorB) {
        return Vector.rotation(this, vectorB);
    };
    Vector.prototype.cubeMax = function () {
        return Vector.cubeMax(this);
    };
    Vector.prototype.map = function (modifier) {
        return Vector.map(this, modifier);
    };
    Vector.prototype.rearrangeAxes = function (modifier) {
        return Vector.rearrangeAxes(this, modifier);
    };
    Vector.prototype.apply = function (modifier) {
        return Vector.apply(this, modifier);
    };
    Vector.prototype.applyWithin = function (context, modifier) {
        return Vector.applyWithin(this, context, modifier);
    };
    Vector.prototype.to2D = function () {
        return Vector.to2D(this);
    };
    Vector.prototype.toJSON = function () {
        return Vector.toJSON(this);
    };
    Vector.prototype.toObject = function (axisMapping) {
        return Vector.toObject(this, axisMapping);
    };
    Vector.prototype.toObject2D = function () {
        return Vector.toObject2D(this);
    };
    Vector.prototype.toObject3D = function () {
        return Vector.toObject3D(this);
    };
    Vector.prototype.toArray = function () {
        return Vector.toArray(this);
    };
    Vector.prototype.toArray2D = function () {
        return Vector.toArray2D(this);
    };
    Vector.prototype.toArray3D = function () {
        return Vector.toArray3D(this);
    };
    Vector.prototype.toString = function () {
        return Vector.toString(this);
    };
    Vector.prototype.toString2D = function () {
        return Vector.toString2D(this);
    };
    Vector.prototype.toString3D = function () {
        return Vector.toString3D(this);
    };
    return Vector;
}());
/**
 * TODO: .length.
 * TODO: toUnitVector()
 * TODO: toPolar()
 * TODO: ortogonal(), normal()
 * TODO: rotate should accept just a number as a rotatation to rotate along z axis
 */

var Transform = /** @class */ (function () {
    function Transform(translate, 
    // public center: Vector = Vector.zero(),
    rotate, scale) {
        if (translate === void 0) { translate = Vector.zero(); }
        if (rotate === void 0) { rotate = Vector.zero(); }
        if (scale === void 0) { scale = Vector.cube(); }
        this.translate = translate;
        this.rotate = rotate;
        this.scale = scale;
    }
    Transform.neutral = function () {
        return new Transform();
    };
    Transform.translate = function (translate) {
        return Transform.fromObject({ translate: translate });
    };
    Transform.rotate = function (rotate) {
        return Transform.fromObject({ rotate: rotate });
    };
    Transform.scale = function (scale) {
        return Transform.fromObject({ scale: scale });
    };
    Transform.fromObject = function (transform) {
        if (transform instanceof Transform) {
            return transform;
        }
        return Transform.clone(transform);
    };
    // Note: Static methods bellow have instance equivalents
    Transform.clone = function (transform) {
        var optionsFull = __assign(__assign({}, Transform.neutral()), transform);
        return new Transform(Vector.fromObject(optionsFull.translate), 
        // Vector.fromObject(optionsFull.center),
        (typeof optionsFull.rotate === 'number'
            ? Vector.fromArray(0, 0, optionsFull.rotate)
            : Vector.fromObject(optionsFull.rotate)).map(function (angle) { return convertAngle('(rad)', '(rad)', angle); }), typeof optionsFull.scale === 'number'
            ? Vector.cube(optionsFull.scale)
            : Vector.fromObject(optionsFull.scale));
    };
    Transform.cloneDeep = function (transform) {
        var transformFull = Transform.fromObject(transform);
        return new Transform(Vector.fromObject(transformFull.translate).clone(), 
        // Vector.fromObject(transformFull.center).clone(),
        Vector.fromObject(transformFull.rotate).clone(), Vector.fromObject(transformFull.scale).clone());
    };
    Transform.updateWithMutation = function (transform, modifier) {
        var transformObject = Transform.clone(transform);
        var result = modifier(transformObject);
        if (result) {
            return Transform.fromObject(result);
        }
        else {
            return transformObject;
        }
    };
    // TODO: updateWithDeepMutation
    Transform.apply = function (transform, modifier) {
        if (typeof modifier === 'function') {
            return Transform.fromObject(modifier(Transform.fromObject(transform)));
        }
        else {
            return Transform.fromObject(modifier.applyOnTransform(Transform.fromObject(transform)));
        }
    };
    Transform.inverse = function (transform) {
        var transformFull = Transform.fromObject(transform);
        return new Transform(transformFull.translate.negate(), transformFull.rotate.negate(), transformFull.scale.inverse());
    };
    // TODO: isEqual
    Transform.applyOnTransform = function (from, to) {
        var t1 = Transform.fromObject(from);
        var t2 = Transform.fromObject(to);
        return Transform.fromObject({
            rotate: Vector.add(t1.rotate, t2.rotate),
            scale: Vector.multiply(t1.scale, t2.scale),
            translate: Vector.add(t1.translate, t2.translate.apply(t1.updateWithMutation(function (t) {
                // !!!
                t.translate = Vector.zero();
            }))),
        });
    };
    Transform.applyOnVector = function (from, to) {
        var fromObject = Transform.fromObject(from);
        return Vector.fromObject(to)
            .add(fromObject.translate)
            .rotate(fromObject.rotate)
            .multiply(fromObject.scale)
            .stripInfatesimals();
    };
    Transform.pick = function (transform) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        var transformObject = Transform.fromObject(transform);
        return Transform.neutral().updateWithMutation(function (t) {
            var e_1, _a;
            try {
                for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var key = keys_1_1.value;
                    t[key] = transformObject[key];
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    };
    Transform.toJSON = function (transform) {
        return Transform.toObject(transform);
    };
    Transform.toObject = function (transform) {
        var transformObject = Transform.fromObject(transform);
        var translate = transformObject.translate, rotate = transformObject.rotate, scale = transformObject.scale;
        var json = {};
        if (!Vector.isZero(translate)) {
            json.translate = translate.toObject();
        }
        if (!Vector.isZero(rotate)) {
            json.rotate = rotate.toObject();
        }
        if (!Vector.isEqual(scale, Vector.cube())) {
            json.scale = scale.toObject();
        }
        return json;
    };
    // Note: Bellow are instance equivalents of static methods
    // TODO: Auto-generate them
    Transform.prototype.clone = function () {
        return Transform.clone(this);
    };
    Transform.prototype.cloneDeep = function () {
        return Transform.cloneDeep(this);
    };
    Transform.prototype.updateWithMutation = function (modifier) {
        return Transform.updateWithMutation(this, modifier);
    };
    Transform.prototype.apply = function (modifier) {
        return Transform.apply(this, modifier);
    };
    Transform.prototype.inverse = function () {
        return Transform.inverse(this);
    };
    Transform.prototype.applyOnTransform = function (to) {
        return Transform.applyOnTransform(this, to);
    };
    Transform.prototype.applyOnVector = function (to) {
        return Transform.applyOnVector(this, to);
    };
    Transform.prototype.pick = function () {
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        return Transform.pick.apply(Transform, __spreadArray([this], __read(keys), false));
    };
    Transform.prototype.toJSON = function () {
        return Transform.toJSON(this);
    };
    Transform.prototype.toObject = function () {
        return Transform.toObject(this);
    };
    Transform.prototype.toString = function () {
        // TODO: Better
        return JSON.stringify(Transform.toJSON(this));
    };
    return Transform;
}());

var BoundingBox = /** @class */ (function () {
    function BoundingBox(transform) {
        this.transform = transform;
    }
    BoundingBox.cube = function () {
        return new BoundingBox(Transform.neutral());
    };
    // TODO: Maybe square
    BoundingBox.fromTransform = function (transform) {
        return new BoundingBox(Transform.fromObject(transform));
    };
    BoundingBox.fromDomRect = function (domRect) {
        var x = domRect.x, y = domRect.y, width = domRect.width, height = domRect.height;
        return BoundingBox.fromPoints(new Vector(x, y), new Vector(x + width, y + height));
    };
    BoundingBox.merge = function () {
        var boundingBoxes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            boundingBoxes[_i] = arguments[_i];
        }
        return BoundingBox.fromPoints.apply(BoundingBox, __spreadArray([], __read(boundingBoxes.flatMap(function (boundingBox) { return [boundingBox.topLeft, boundingBox.bottomRight]; })), false));
    };
    BoundingBox.fromPoints = function () {
        var e_1, _a, e_2, _b;
        var points = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            points[_i] = arguments[_i];
        }
        var vectorMin = {};
        var vectorMax = {};
        try {
            for (var points_1 = __values(points), points_1_1 = points_1.next(); !points_1_1.done; points_1_1 = points_1.next()) {
                var point = points_1_1.value;
                try {
                    for (var AXES_1 = (e_2 = void 0, __values(AXES)), AXES_1_1 = AXES_1.next(); !AXES_1_1.done; AXES_1_1 = AXES_1.next()) {
                        var axis = AXES_1_1.value;
                        if (vectorMin[axis] === undefined || (point[axis] !== undefined && vectorMin[axis] > point[axis])) {
                            vectorMin[axis] = point[axis];
                        }
                        if (vectorMax[axis] === undefined || (point[axis] !== undefined && vectorMax[axis] < point[axis])) {
                            vectorMax[axis] = point[axis];
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (AXES_1_1 && !AXES_1_1.done && (_b = AXES_1.return)) _b.call(AXES_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (points_1_1 && !points_1_1.done && (_a = points_1.return)) _a.call(points_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var a = Vector.fromObject(vectorMin);
        var b = Vector.fromObject(vectorMax);
        var translate = Vector.add(a, b).half();
        var scale = b.subtract(a);
        return BoundingBox.fromTransform({ translate: translate, scale: scale });
    };
    Object.defineProperty(BoundingBox.prototype, "size", {
        // TODO: circumscribed
        /*
        TODO:
        public clone() {
            return new BoundingBox(this.center, this.size, this.rotation);
        }
    
        public cloneDeep() {
            return new BoundingBox(
                this.center.clone(),
                this.size.clone(),
                this.rotation,
            );
        }
        */
        /**
         * Get size of the bounding box
         */
        get: function () {
            return this.transform.scale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingBox.prototype, "width", {
        /**
         * Get width of the bounding box
         */
        get: function () {
            return this.transform.scale.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingBox.prototype, "height", {
        /**
         * Get width of the bounding box
         */
        get: function () {
            return this.transform.scale.y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingBox.prototype, "rotation", {
        /**
         * Get rotation of the bounding box
         */
        get: function () {
            return this.transform.rotate.z;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingBox.prototype, "center", {
        /**
         * Get center point of the bounding box
         */
        get: function () {
            return this.transform.translate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingBox.prototype, "topLeft", {
        /**
         * Get top-left point of the bounding box
         *
         * 🟥🟦
         * 🟦🟦
         */
        get: function () {
            return this.corner2D({ x: -0.5, y: -0.5 });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingBox.prototype, "topRight", {
        /**
         * Get top-right point of the bounding box
         *
         * 🟦🟥
         * 🟦🟦
         */
        get: function () {
            return this.corner2D({ x: 0.5, y: -0.5 });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingBox.prototype, "bottomLeft", {
        /**
         * Get bottom-left point of the bounding box
         *
         * 🟦🟦
         * 🟥🟦
         */
        get: function () {
            return this.corner2D({ x: -0.5, y: 0.5 });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingBox.prototype, "bottomRight", {
        /**
         * Get bottom-right point of the bounding box
         *
         * 🟦🟦
         * 🟦🟥
         */
        get: function () {
            return this.corner2D({ x: 0.5, y: 0.5 });
        },
        enumerable: false,
        configurable: true
    });
    // TODO: Also 3D versions
    // TODO: setters
    BoundingBox.prototype.intersects = function (position) {
        var positionTransformed = position.apply(this.transform.inverse());
        // Note: This stupidity is here because javascript is sometimes not precise in the last decimal digit
        var bound = 0.5 + ε;
        return (-bound <= positionTransformed.x &&
            -bound <= positionTransformed.y &&
            bound >= positionTransformed.x &&
            bound >= positionTransformed.y);
    };
    // !! TODO: intersects for another BoundingBox
    BoundingBox.prototype.applyTransform = function (transform) {
        // TODO: Same pattern as Vector and Transform
        // TODO: Immutable
        this.transform = this.transform.apply(Transform.fromObject(transform));
    };
    BoundingBox.prototype.corner2D = function (relativePosition) {
        return (this.center
            .add(this.transform.scale.multiply(relativePosition))
            // TODO: 🔼 Also consider rotation; originally used broken: .within(this.transform.pick('rotate', 'scale'), (center) => center.add(relativePosition))
            .stripInfatesimals());
    };
    BoundingBox.prototype.toString = function () {
        // TODO: Better
        return JSON.stringify(Transform.toJSON(this.transform));
    };
    return BoundingBox;
}());

function extractValuesFromStyle(functionName, cssTransform) {
    var matchInner = new RegExp(functionName + "\\((?<inner>.*)\\)", 'is').exec(cssTransform);
    if (!matchInner || !matchInner.groups || !matchInner.groups.inner) {
        return null;
    }
    var parts = matchInner.groups.inner.split(/\s*[\,\s]\s*/gs).filter(function (part) { return part !== ''; });
    var values = parts.map(function (part) {
        var matchPart = /^(?<value>\-?\d+(\.\d+)?)(?<unit>.*)$/.exec(part);
        if (!matchPart || !matchPart.groups) {
            return { value: 0 };
        }
        var _a = matchPart.groups, value = _a.value, unit = _a.unit;
        return { value: parseFloat(value), unit: unit };
    });
    return values;
}

/**
 * Count minimum and maximum on large arrays without hitting RangeError: Maximum call stack size exceeded
 */
function minmax(array) {
    var e_1, _a;
    var min = array[0];
    var max = array[0];
    try {
        for (var array_1 = __values(array), array_1_1 = array_1.next(); !array_1_1.done; array_1_1 = array_1.next()) {
            var n = array_1_1.value;
            if (n > max)
                max = n;
            if (n < min)
                min = n;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { min: min, max: max };
}
/**
 * TODO: !!! Use this util istead of Math.min and Math.max
 */

function showValue(fractionDigits, value) {
    if (fractionDigits > 9) {
        throw new Error("Max fractionDigits can be 9.");
    }
    var e = Math.pow(10, fractionDigits);
    return (Math.round(value * e) / e).toString();
    // Note: Not doing this way to prevent mess with RegEx> value.toFixed(fractionDigits).replace(/0+$/, '') +
}

function showValueWithUnit(unit, fractionDigits, value) {
    return showValue(fractionDigits, value) + unit.replace(/^\(.*\)$/, '');
}

function _rotateFromStyle(cssTransform) {
    var values = extractValuesFromStyle('rotate', cssTransform);
    if (!values) {
        return null;
    }
    return convertAngle(values[0].unit || '(deg)', '(rad)', values[0].value);
}

function _scaleFromStyle(cssTransform) {
    var values = extractValuesFromStyle('scale', cssTransform);
    if (!values) {
        return null;
    }
    return Vector.fromArray.apply(Vector, __spreadArray(__spreadArray([], __read(values.map(function (_a) {
        var value = _a.value;
        return value;
    }).slice(0, 2)), false), [1], false));
}

function _translateFromStyle(cssTransform) {
    var values = extractValuesFromStyle('translate', cssTransform);
    if (!values) {
        return null;
    }
    return Vector.fromArray(values.map(function (_a) {
        var value = _a.value;
        return value;
    }).slice(0, 2));
}

/**
 * Converts css style.transform or svg transform to Transform object
 * Note: This function has a bit different philosophy than transformToStyle because it is trying to extract a Transform from the style in any format and you do not need to declare which format is it.
 */
function transformFromStyle(cssTransform) {
    var translate = _translateFromStyle(cssTransform);
    var rotate = _rotateFromStyle(cssTransform);
    var scale = _scaleFromStyle(cssTransform);
    var transform = {};
    if (translate) {
        transform.translate = translate;
    }
    if (rotate) {
        transform.rotate = rotate;
    }
    if (scale) {
        transform.scale = scale;
    }
    return Transform.fromObject(transform);
    // TODO: compatibility mode for other css transform directives as matrix, scaleX, scaleY, etc.
}

function _transformAngleToStyle(styleFormat, value) {
    return showValueWithUnit(styleFormat.angleUnit, styleFormat.fractionDigits, convertAngle('rad', styleFormat.angleUnit, value));
}

function _transformRotateToStyle(styleFormat, rotate) {
    var z = rotate.z;
    if (!z) {
        return null;
    }
    // TODO: How about 3D rotation
    return "rotate(" + _transformAngleToStyle(styleFormat, z) + ")";
}

function _transformScaleToStyle(styleFormat, scale) {
    if (Vector.isEqual(scale, Vector.square()) || Vector.isEqual(scale, Vector.cube())) {
        return null;
    }
    var x = scale.x, y = scale.y;
    return "scale(" + showValue(styleFormat.fractionDigits, x) + styleFormat.valuesDelimiter + showValue(styleFormat.fractionDigits, y) + ")";
}

function _transformDimensionToStyle(styleFormat, value) {
    return showValueWithUnit(styleFormat.dimensionUnit, styleFormat.fractionDigits, value);
}

function _transformTranslateToStyle(styleFormat, translate) {
    if (Vector.isZero(translate)) {
        return null;
    }
    var x = translate.x, y = translate.y;
    return "translate(" + _transformDimensionToStyle(styleFormat, x) + styleFormat.valuesDelimiter + _transformDimensionToStyle(styleFormat, y) + ")";
}

function transformToStyle(styleFormat, transform) {
    var translate = transform.translate, rotate = transform.rotate, scale = transform.scale;
    return [
        _transformTranslateToStyle(styleFormat, translate),
        _transformRotateToStyle(styleFormat, rotate),
        _transformScaleToStyle(styleFormat, scale),
    ]
        .filter(function (_) { return _ !== null; })
        .join(' ');
}

var CSS_FORMAT = {
    dimensionUnit: 'px',
    angleUnit: 'deg',
    valuesDelimiter: ',',
    fractionDigits: 3,
};
var transformToStyleCss = transformToStyle.bind(null, CSS_FORMAT);

function applyTransformOnHtmlElement(transform, element) {
    element.style.transform = transformToStyleCss(Transform.apply(transformFromStyle(element.style.transform), Transform.fromObject(transform)));
}

var SVG_FORMAT = {
    dimensionUnit: '(px)',
    angleUnit: '(deg)',
    valuesDelimiter: ' ',
    fractionDigits: 3,
};
var transformToStyleSvg = transformToStyle.bind(null, SVG_FORMAT);

function applyTransformOnSvgElement(transform, element) {
    element.setAttribute('transform', transformToStyleSvg(Transform.apply(transformFromStyle(element.getAttribute('transform') || ''), Transform.fromObject(transform))));
}

function applyTransformOnElement(transform, element) {
    // TODO: Try to preserve options of the transform (with function transformFormatFromStyle)
    switch (element.tagName) {
        // TODO: Probbably better recognition between SVGGElement vs HTMLElement
        case 'g':
            applyTransformOnSvgElement(transform, element);
            break;
        default:
            applyTransformOnHtmlElement(transform, element);
    }
}

export { AXES, BoundingBox, CSS_FORMAT, NEGLIGIBLE_THRESHOLD, Transform, Vector, _rotateFromStyle, _scaleFromStyle, _transformAngleToStyle, _transformDimensionToStyle, _transformRotateToStyle, _transformScaleToStyle, _transformTranslateToStyle, _translateFromStyle, applyTransformOnElement, applyTransformOnHtmlElement, applyTransformOnSvgElement, convertAngle, extractValuesFromStyle, fullAngle, minmax, modulo, showValue, showValueWithUnit, stripInfatesimal, transformFromStyle, transformToStyle, transformToStyleCss, transformToStyleSvg };
//# sourceMappingURL=xyzt.js.map
